export const ashtrayLyrics = [
  { text: "*Growls*", start: 0, end: 6 },
  { text: "Mmm", start: 15.7, end: 17 },
  { text: "Imma start the rapture", start: 17, end: 19.2 },
  { text: "It's not what you did", start: 19.2, end: 21.8 },
  { text: "It's who you chose", start: 21.8, end: 25 },
  { text: "I put you on pedestal's", start: 25, end: 27.07 },
  { text: "I was ten toes for ya", start: 27.07, end: 29 },
  { text: "T-ten toes for ya", start: 29, end: 31 },
  { text: "I have tried to shove it down", start: 31, end: 33 },
  { text: "how you gon' give her g-give her give her my thrown", start: 33, end: 37 },
  { text: "Claiming not worry bout someone I used to know", start: 37, end: 40.5 },
  { text: "Chew the fat I wish you would convince me say I'm misunderstood", start: 40.5, end: 44.2 },
  { text: "Your intentions were for good", start: 44, end: 46 },
  { text: "Good", start: 46, end: 46.5 },
  { text: "Good", start: 46.5, end: 47 },
  { text: "Good", start: 47, end: 47.5 },
  { text: "Oh I've got bags of pictures that I intend to burn", start: 47.5, end: 52.2 },
  { text: "Ain't got no more love to give ya now that I've discerned", start: 52.2, end: 56.46 },
  { text: "Forever don't last when it's someone's love you have to earn", start: 56.46, end: 62.08 },
  { text: "Oh oh oh oh", start: 62.08, end: 63 },
  { text: "To think I loved you despite", start: 63, end: 66 },
  { text: "you tearing us to points of no return", start: 66, end: 70.9 },
  { text: "To find myself is the only way", start: 70.9, end: 74.5 },
  { text: "To hit you where it hurts", start: 74.5, end: 79 },
  { text: "It's in your tone", start: 79, end: 80 },
  { text: "It's in your eyes", start: 80, end: 81.8 },
  { text: "It's in the way you sing sweet little lies", start: 81.8, end: 86.03 },
  { text: "So I'll go, I know I need, cause I can't deny", start: 86.03, end: 91.83 },
  { text: "I can't deny", start: 91.83, end: 96 },
  { text: "You don't wanna stay", start: 96, end: 97.6 },
  { text: "So when you walk out the door I pray", start: 97.6, end: 101.95 },
  { text: "I pray the weight", start: 101.95, end: 104.03 },
  { text: "Of your memory", start: 104.03, end: 105.53 },
  { text: "Pulls me away", start: 105.53, end: 108 },
  { text: "Lord", start: 108, end: 111 },
  { text: "For you I wept in constant grief", start: 111, end: 115 },
  { text: "Hope is not a strategy", start: 115, end: 118.6 },
  { text: "Spineless I could never be again", start: 118.6, end: 125.21 },
  { text: "After all I sacrificed", start: 127, end: 131 },
  { text: "You still have the nerve", start: 131, end: 134 },
  { text: "To crack", start: 134, end: 135 },
  { text: "A smile", start: 135, end: 137.5 },
  { text: "So in the meanwhile", start: 137.5, end: 140.3 },
  { text: "Mm", start: 140.3, end: 143.5 },
  { text: "I want nothin'", start: 143.5, end: 145 },
  { text: "Don't don't", start: 145, end: 145.7 },
  { text: "Want nothin' from you", start: 145.7, end: 147.5 },
  { text: "Fuck I look like tryna keep things cordial", start: 147.5, end: 151.5 },
  { text: "Letting you back into my life and fallin' for your bribes", start: 151.5, end: 154 },
  { text: "I can finally recognize I was never your type", start: 154, end: 158.5 },
  { text: "A hit dog gon' holler (you do)", start: 158.5, end: 160 },
  { text: "Soon as I take back my power", start: 160, end: 161.8 },
  { text: "You get to yelpin once I find the sense to verbally squabble", start: 161.8, end: 165.5 },
  { text: "I let these words ricochet on ya", start: 165.5, end: 168.88 },
  { text: "Go on bark louder won't ya", start: 168.88, end: 170.5 },
  { text: "Go on bark louder won't ya", start: 170.5, end: 172 },
  { text: "Won't ya", start: 172, end: 172.5 },
  { text: "Won't ya", start: 172.5, end: 173 },
  { text: "Won't ya", start: 173, end: 173.5 },
  { text: "Won't ya", start: 173.5, end: 174 },
  { text: "Go go girl go on move ya body", start: 174, end: 176.96 },
  { text: "Go go", start: 176.96, end: 178.5 },
  { text: "Go girl go on move ya body", start: 178.5, end: 180.6 },
  { text: "Go go", start: 180.6, end: 182.4 },
  { text: "Go girl go on move ya body", start: 182.4, end: 184.9 },
  { text: "Go go", start: 184.9, end: 186 },
  { text: "Go girl go on move ya body", start: 186, end: 191 },
  { text: "It makes you sad to see me livin'", start: 191, end: 194.55 },
  { text: "The thought of me finding myself makes you confused", start: 194.55, end: 199.18 },
  { text: "Confused", start: 199.18, end: 201 },
  { text: "Yeah", start: 201, end: 207 },
  { text: "Now it's me that you'll be grieving", start: 207, end: 210.2 },
  { text: "Can't you can't control me like you used to", start: 210.2, end: 215.05 },
  { text: "Like you used to", start: 215.05, end: 219.5 },
  { text: "hey", start: 219.5, end: 220 },
] as const satisfies ReadonlyArray<{ readonly text: string, readonly start?: number, readonly end?: number }>;
